import React, { createContext, useContext } from 'react';
import { useAuth } from './AuthContext';

// Definim culorile pentru fiecare rol
const ROLE_THEMES = {
  admin: {
    name: 'admin',
    primary: 'emerald',
    primaryHex: '#10b981',
    primaryBg: 'bg-emerald-500',
    primaryBgHover: 'hover:bg-emerald-600',
    primaryText: 'text-emerald-600',
    primaryTextHover: 'hover:text-emerald-600',
    primaryBgLight: 'bg-emerald-100',
    primaryBorder: 'border-emerald-500',
    primaryBorderLight: 'border-emerald-300',
    primaryBgLightHover: 'hover:bg-emerald-50',
    primaryRing: 'focus:ring-emerald-500',
    spinnerBorder: 'border-emerald-500',
    gradientFrom: 'from-emerald-500',
    gradientTo: 'to-teal-600',
    borderColor: 'border-emerald-500',
    textColor: 'text-emerald-600',
  },
  medic: {
    name: 'medic',
    primary: 'rose',
    primaryHex: '#f43f5e',
    primaryBg: 'bg-rose-500',
    primaryBgHover: 'hover:bg-rose-600',
    primaryText: 'text-rose-600',
    primaryTextHover: 'hover:text-rose-600',
    primaryBgLight: 'bg-rose-100',
    primaryBorder: 'border-rose-500',
    primaryBorderLight: 'border-rose-300',
    primaryBgLightHover: 'hover:bg-rose-50',
    primaryRing: 'focus:ring-rose-500',
    spinnerBorder: 'border-rose-500',
    gradientFrom: 'from-rose-500',
    gradientTo: 'to-red-600',
    borderColor: 'border-rose-500',
    textColor: 'text-rose-600',
  },
  asistent: {
    name: 'asistent',
    primary: 'violet',
    primaryHex: '#8b5cf6',
    primaryBg: 'bg-violet-500',
    primaryBgHover: 'hover:bg-violet-600',
    primaryText: 'text-violet-600',
    primaryTextHover: 'hover:text-violet-600',
    primaryBgLight: 'bg-violet-100',
    primaryBorder: 'border-violet-500',
    primaryBorderLight: 'border-violet-300',
    primaryBgLightHover: 'hover:bg-violet-50',
    primaryRing: 'focus:ring-violet-500',
    spinnerBorder: 'border-violet-500',
    gradientFrom: 'from-violet-500',
    gradientTo: 'to-purple-600',
    borderColor: 'border-violet-500',
    textColor: 'text-violet-600',
  }
};

// Default theme (folosit la login)
const DEFAULT_THEME = ROLE_THEMES.admin;

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const { user } = useAuth();
  
  // Selectează tema bazată pe rol
  const theme = user?.role ? (ROLE_THEMES[user.role] || DEFAULT_THEME) : DEFAULT_THEME;
  
  return (
    <ThemeContext.Provider value={{ theme, ROLE_THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export { ROLE_THEMES };
